import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import Navigation from "@/components/Navigation";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import TeamPage from "@/pages/TeamPage";
import ReviewsPage from "@/pages/ReviewsPage";
import WerkwijzePage from "@/pages/WerkwijzePage";
import ContactPage from "@/pages/ContactPage";
import BookingPage from "@/pages/BookingPage";
import GalleryPage from "@/pages/GalleryPage";
import TransformationsPage from "@/pages/TransformationsPage";
import AdminPage from "@/pages/AdminPage";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A]">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/over-ons" element={<AboutPage />} />
          <Route path="/diensten" element={<ServicesPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/werkwijze" element={<WerkwijzePage />} />
          <Route path="/galerij" element={<GalleryPage />} />
          <Route path="/transformaties" element={<TransformationsPage />} />
          <Route path="/arena-admin" element={<AdminPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/boeken" element={<BookingPage />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
